// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9g-0";
export var optionCard = "_9g-1";